export default "__VITE_ASSET__BvvvUaX___"